<template>
  <div class="stores-page c:col-start-stretch">
    <CEmpty v-if="list.length == 0 && !loading" text="暂无店铺" />
    <div class="store-list">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="getStoreList"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          class="store-list-item c:col-between-start"
          @click="throttledOnStoreTileClick(item)"
        >
          <div class="store-name">{{ item.storeName }}</div>
          <div class="store-manager-name">店长 {{ item.managerName }}</div>
          <div class="salers-count">销售数量 {{ item.caNumber }}人</div>
        </div></van-list
      >
      <CBottomPad is-tab-page />
    </div>
  </div>
</template>
<script>
import { getRMStoreList } from "@/api";
import CBottomPad from "@/components/common/CBottomPad.vue";
import CEmpty from "@/components/common/Empty.vue";
import normalPage from "@/mixins/normal-page";
import { throttle } from "@/utils";
import { mapState } from "vuex";
export default {
  mixins: [normalPage],
  components: {
    CEmpty,
    CBottomPad,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      finishedText: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  created() {
    this.throttledOnStoreTileClick = throttle(this.openStoreDetail, 500);
  },
  mounted() {
    // this.list = this.user.stores;
  },
  methods: {
    async getStoreList() {
      try {
        this.loading = true;
        this.list = [];
        const res = await getRMStoreList();
        this.list = res;
        console.log("getStoreList", this.list);
        this.finishedText = "";
      } catch (error) {
        if (error?.message) this.$toast(error.message);
        this.finishedText = "";
      } finally {
        this.loading = false;
        this.finished = true;
      }
    },
    openStoreDetail(item) {
      this.$router.push({
        name: `AreaManagerStoreDetail`,
        query: {
          storeId: item.storeId,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.stores-page {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  user-select: none;
}

.store-list {
  flex: 1;
  width: 100%;
  // height: 0;
  padding-top: 5/20rem;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 0;

  .store-list-item {
    gap: 6/20rem;

    box-sizing: border-box;
    width: 100%;
    height: 98/20rem;
    padding: 28/40rem 40/40rem;
    background: #fff;
    margin-bottom: 5/20rem;

    .store-name {
      height: 20/20rem;
      margin-bottom: 4/20rem;
      line-height: 20/20rem;
      font-size: 14/20rem;
      font-weight: 500;
      color: #000;
    }

    .store-manager-name,
    .salers-count {
      height: 17/20rem;
      line-height: 17/20rem;
      font-size: 12/20rem;
      color: #7d7d7d;
    }
  }
}
</style>
